import { jsx as _jsx } from "react/jsx-runtime";
import { FlowStepMessage, MessagingContentHolder } from './MessageContainer.styles';
export const MessageContainer = ({
  layoutType,
  children
}) => {
  return /*#__PURE__*/_jsx(FlowStepMessage, {
    layoutType: layoutType,
    children: /*#__PURE__*/_jsx(MessagingContentHolder, {
      children: children
    })
  });
};